import { render, staticRenderFns } from "./ShowCode.vue?vue&type=template&id=d36719be"
import script from "./ShowCode.vue?vue&type=script&lang=js"
export * from "./ShowCode.vue?vue&type=script&lang=js"
import style0 from "./ShowCode.vue?vue&type=style&index=0&id=d36719be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports